import { useEffect, useState } from "react";
import { Button, Card, Icons, Image, Text } from "../../design";
import {
    calcDiscountValue,
    findMinAmount,
    getDiscountAmount,
    truncateText,
    getCurrencyDisplayInternationalized,
    getFinalPriceAfterLoyaltyDiscountBh,
    getFinalPriceAfterLoyaltyDiscountYotpo,
    getFinalPriceAfterLoyaltyDiscountInfluence,
    getFinalPriceAfterLoyaltyDiscountRivo,
    getFinalPriceAfterLoyaltyDiscountOkendo,
    getFinalPriceAfterLoyaltyDiscountRiseAi,
} from "../../utils/helpers";
import { translate } from "../../utils/translations";
import { useLoop } from "../loop-provider";
import { useContract } from "../contract-provider";
import { useLoyalty } from "../loyalty-provider";

function ProductCard(props: any) {
    const { store, preferences, myshopify_domain, locale, country } = useLoop();
    const contractProvider = useContract();
    const {
        points,
        minRedeemablePoints,
        isLoading,
        maxRedeemablePoints,
        pointsConversionRate,
        availableBuckets,
        loyaltyProvider,
        yotpoData,
        influenceData,
        rivoData,
        okendoData,
        riseaiData,
    } = useLoyalty();

    const [product, setproduct] = useState(null);
    const [discountedPrice, setdiscountedPrice] = useState(null);
    const [_ready, _setready] = useState(false);
    const [loyaltyDiscount, setLoyaltyDiscount] = useState(null);

    function isSingleLoyaltyConnected() {
        let connectedLoyaltyProviderCount = 0;
        if (loyaltyProvider) connectedLoyaltyProviderCount++;
        if (yotpoData?.loyaltyProvider) connectedLoyaltyProviderCount++;
        if (influenceData?.loyaltyProvider) connectedLoyaltyProviderCount++;
        if (rivoData?.loyaltyProvider) connectedLoyaltyProviderCount++;
        if (okendoData?.loyaltyProvider) connectedLoyaltyProviderCount++;
        if (riseaiData?.loyaltyProvider) connectedLoyaltyProviderCount++;
        return connectedLoyaltyProviderCount === 1;
    }

    useEffect(() => {
        let _product = props.product;
        setproduct(_product);
        if (props.type.includes('upsell')) {
            let _discPrice = null;
            if (preferences.cp_prod_add_one_time && preferences.cp_prod_add_product) {
                if (_product.upsell_type == 'BOTH' || _product.upsell_collection_type == 'BOTH') {
                    if (_product?.upsell_subscription_discount_type != 'BASED_ON_SELLING_PLAN') {
                        if (_product?.upsell_collection_subscription_discount_type && _product?.upsell_collection_discount_type) {
                            _discPrice = findMinAmount(
                                getDiscountAmount(Number(_product.price), _product.upsell_collection_subscription_discount_type, _product.upsell_collection_subscription_discount_type === 'BASED_ON_SELLING_PLAN' ? Number(_product.sp_discounted_price) : Number(_product.upsell_collection_subscription_discount_value)),
                                getDiscountAmount(Number(_product.price), _product.upsell_collection_discount_type, Number(_product.upsell_collection_discount_value)),
                            )
                        }
                        if (_product?.upsell_subscription_discount_type && _product?.upsell_discount_type) {
                            if (_product?.subscription_plan_available) {
                                _discPrice = findMinAmount(
                                    getDiscountAmount(Number(_product.price), _product.upsell_subscription_discount_type, Number(_product.upsell_subscription_discount_value)),
                                    getDiscountAmount(Number(_product.price), _product.upsell_discount_type, Number(_product.upsell_discount_value)),
                                )
                            } else {
                                _discPrice = findMinAmount(
                                    getDiscountAmount(Number(_product.price), _product.upsell_subscription_discount_type, Number(_product.upsell_discount_value)),
                                    getDiscountAmount(Number(_product.price), _product.upsell_discount_type, Number(_product.upsell_discount_value)),
                                )
                            }
                        }
                    } else {
                        _discPrice = Math.min(_product.sp_discounted_price, _product.upsell_discounted_price)
                    }
                } else if (_product.upsell_type == 'SUBSCRIPTION' || _product.upsell_collection_type == 'SUBSCRIPTION') {
                    if (_product?.upsell_subscription_discount_type != 'BASED_ON_SELLING_PLAN') {
                        if (_product?.upsell_collection_subscription_discount_type && _product?.upsell_collection_discount_type) {
                            _discPrice = findMinAmount(
                                getDiscountAmount(Number(_product.price), _product.upsell_collection_subscription_discount_type, Number(_product.upsell_collection_subscription_discount_value)),
                                getDiscountAmount(Number(_product.price), _product.upsell_collection_discount_type, Number(_product.upsell_collection_discount_value)),
                            )
                        }
                        if (_product?.upsell_subscription_discount_type && _product?.upsell_discount_type) {
                            _discPrice = findMinAmount(
                                getDiscountAmount(Number(_product.price), _product.upsell_subscription_discount_type, Number(_product.upsell_subscription_discount_value)),
                                getDiscountAmount(Number(_product.price), _product.upsell_discount_type, Number(_product.upsell_discount_value)),
                            )
                        }
                    } else {
                        _discPrice = _product.sp_discounted_price;
                    }
                } else {
                    if (_product?.sp_discounted_price && _product?.upsell_discounted_price) {
                        _discPrice = Math.min(_product.sp_discounted_price, _product.upsell_discounted_price)
                    }
                    else if (_product?.sp_discounted_price) {
                        _discPrice = _product.sp_discounted_price;
                    }
                    else {
                        _discPrice = _product.upsell_discounted_price;
                    }
                }
            } else if (preferences.cp_prod_add_one_time) {
                _discPrice = _product.upsell_discounted_price;
            } else if (preferences.cp_prod_add_product) {
                if (_product?.upsell_subscription_discount_type != 'BASED_ON_SELLING_PLAN') {
                    if (_product?.upsell_collection_subscription_discount_type && _product?.upsell_collection_discount_type) {
                        _discPrice = findMinAmount(
                            getDiscountAmount(Number(_product.price), _product.upsell_collection_subscription_discount_type, Number(_product.upsell_collection_subscription_discount_value)),
                            getDiscountAmount(Number(_product.price), _product.upsell_collection_discount_type, Number(_product.upsell_collection_discount_value)),
                        )
                    }
                    if (_product?.upsell_subscription_discount_type && _product?.upsell_discount_type) {
                        _discPrice = findMinAmount(
                            getDiscountAmount(Number(_product.price), _product.upsell_subscription_discount_type, Number(_product.upsell_subscription_discount_value)),
                            getDiscountAmount(Number(_product.price), _product.upsell_discount_type, Number(_product.upsell_discount_value)),
                        )
                    }
                    else {
                        _discPrice = _product.sp_discounted_price;
                    }
                } else {
                    _discPrice = _product.sp_discounted_price;
                }
            }
            if (_discPrice != null) {
                if (_discPrice < parseFloat(_product.price)) {
                    setdiscountedPrice(_discPrice);
                } else if (_discPrice == parseFloat(_product.price)) {
                    setdiscountedPrice(null);
                }
            } else {
                setdiscountedPrice(_discPrice);
            }
            setPriceAfterLoyaltyDiscount(_product, _discPrice);

        } else if (props.type.includes('swap')) {
            let _discPrice = null;
            const isNewDiscount =
                !props?.swapProfileData?.results?.length
                    ? preferences.input_cp_prod_swap_discount === 'NEW'
                    : props.swapProfileData.discountType === 'NEW';

            _discPrice = !_product?.sp_discounted_price && isNewDiscount
                ? calcDiscountValue(_product.price, props.linePricingPolicy?.cycleDiscounts || [], contractProvider.contract.billing_attempt_success_count)
                : _product.sp_discounted_price || calcDiscountValue(_product.price, props.linePricingPolicy?.cycleDiscounts || [], contractProvider.contract.billing_attempt_success_count);

            if (props?.swapProfileData.incentiveType === "DISCOUNT" && props?.swapProfileData?.incentiveConfig?.discountType !== "NONE") {
                _discPrice = getDiscountAmount(_discPrice, props?.swapProfileData?.incentiveConfig?.discountType, props?.swapProfileData?.incentiveConfig?.discountValue);
            }
            if (_discPrice != _product.price) {
                setdiscountedPrice(_discPrice);
            }
        } else if (props.type.includes('campaign-action')) {
            setdiscountedPrice(_product?.discounted_price);
            setPriceAfterLoyaltyDiscount(_product, _product?.discounted_price);
        }
        _setready(true);
    }, [props.type, props.product, isLoading, yotpoData, influenceData, rivoData, okendoData, riseaiData]);

    if (!_ready) {
        return null;
    }

    function setPriceAfterLoyaltyDiscount(_product: any, _discPrice: number) {
        if (
            isSingleLoyaltyConnected() &&
            !_product.isBYOB &&
            !_product.isPreset &&
            (props.type.includes("upsell") || props.type.includes("campaign-action")) &&
            preferences.cp_show_upsell_loyalty_discount &&
            loyaltyProvider === "bubblehouse"
        ) {
            const loyaltyDiscountData = getFinalPriceAfterLoyaltyDiscountBh(
                _discPrice,
                minRedeemablePoints,
                maxRedeemablePoints,
                points,
                availableBuckets,
                pointsConversionRate,
                isLoading,
            );
            setLoyaltyDiscount(loyaltyDiscountData);
            if (loyaltyDiscountData.isDiscounted) {
                setdiscountedPrice(loyaltyDiscountData.discountedPrice);
            }
        }

        if (
            isSingleLoyaltyConnected() &&
            !_product.isBYOB &&
            !_product.isPreset &&
            (props.type.includes("upsell") || props.type.includes("campaign-action")) &&
            preferences.cp_show_upsell_loyalty_discount &&
            riseaiData &&
            riseaiData.loyaltyProvider
        ) {
            const loyaltyDiscountData = getFinalPriceAfterLoyaltyDiscountRiseAi(
                _discPrice,
                riseaiData.credits,
                riseaiData.isLoading,
            );
            setLoyaltyDiscount(loyaltyDiscountData);
            if (loyaltyDiscountData.isDiscounted) {
                setdiscountedPrice(loyaltyDiscountData.discountedPrice);
            }
        }

        if (
            isSingleLoyaltyConnected() &&
            !_product.isBYOB &&
            !_product.isPreset &&
            (props.type.includes("upsell") || props.type.includes("campaign-action")) &&
            preferences.cp_show_upsell_loyalty_discount &&
            yotpoData &&
            yotpoData.loyaltyProvider
        ) {
            const loyaltyDiscountData = getFinalPriceAfterLoyaltyDiscountYotpo(
                _discPrice,
                yotpoData.points,
                yotpoData.redeemRule,
                yotpoData.isLoading,
                contractProvider?.contract?.total_line_item_discounted_price,
                1,
            );
            setLoyaltyDiscount(loyaltyDiscountData);
            if (loyaltyDiscountData.isDiscounted) {
                setdiscountedPrice(loyaltyDiscountData.discountedPrice);
            }
        }

        if (
            isSingleLoyaltyConnected() &&
            !_product.isBYOB &&
            !_product.isPreset &&
            (props.type.includes("upsell") || props.type.includes("campaign-action")) &&
            preferences.cp_show_upsell_loyalty_discount &&
            influenceData &&
            influenceData.loyaltyProvider
        ) {
            const loyaltyDiscountData = getFinalPriceAfterLoyaltyDiscountInfluence(
                _discPrice,
                influenceData.points,
                influenceData.redeemRule,
                influenceData.isLoading,
                1,
            );
            setLoyaltyDiscount(loyaltyDiscountData);
            if (loyaltyDiscountData.isDiscounted) {
                setdiscountedPrice(loyaltyDiscountData.discountedPrice);
            }
        }
        if (
            isSingleLoyaltyConnected() &&
            !_product.isBYOB &&
            !_product.isPreset &&
            (props.type.includes("upsell") || props.type.includes("campaign-action")) &&
            preferences.cp_show_upsell_loyalty_discount &&
            rivoData &&
            rivoData.loyaltyProvider
        ) {
            const loyaltyDiscountData = getFinalPriceAfterLoyaltyDiscountRivo(
                _discPrice,
                rivoData.points,
                rivoData.availableRewardsList,
                rivoData.isLoading,
                1,
            );
            setLoyaltyDiscount(loyaltyDiscountData);
            if (loyaltyDiscountData.isDiscounted) {
                setdiscountedPrice(loyaltyDiscountData.discountedPrice);
            }
        }

        if (
            isSingleLoyaltyConnected() &&
            !_product.isBYOB &&
            !_product.isPreset &&
            (props.type.includes("upsell") || props.type.includes("campaign-action")) &&
            preferences.cp_show_upsell_loyalty_discount &&
            okendoData &&
            okendoData.loyaltyProvider
        ) {
            const loyaltyDiscountData = getFinalPriceAfterLoyaltyDiscountOkendo(
                _discPrice,
                okendoData.points,
                okendoData.redeemRules,
                okendoData.isLoading,
                contractProvider?.contract?.total_line_item_discounted_price,
                1,
            );
            setLoyaltyDiscount(loyaltyDiscountData);
            if (loyaltyDiscountData.isDiscounted) {
                setdiscountedPrice(loyaltyDiscountData.discountedPrice);
            }
        }
    }

    const handleCardClick = (product: any) => {
        if (props.swapProfileData) {
            props.onProductSelect(
                product,
                props.isTrackingEnabled,
                loyaltyDiscount,
                props?.swapProfileData?.swapProfileId,
            );
        } else {
            if (product.isBYOB) {
                let upsellProfileIdParam = "";
                if (props.upsellProfileId) {
                    upsellProfileIdParam = `&upsellProfileId=${props.upsellProfileId}`;
                }
                let _url = `https://${myshopify_domain}${process.env.NEXT_PUBLIC_PROXY_PATH}/bundle/add?bundleId=${product.loopBundleId}&contractId=${contractProvider?.contract?.id}${upsellProfileIdParam}&return_url=${window.location.href}`;
                window.location.href = _url;
            } else {
                props.onProductSelect(
                    product,
                    props.isTrackingEnabled,
                    loyaltyDiscount,
                    props?.swapProfileData?.swapProfileId,
                );
            }
        }
    };

    return (
        <Card
            onClick={() => {
                handleCardClick(product);
            }}
            style={{
                minWidth: "300px",
                border:
                    props.isSelected && props.swapProfileData?.groupingType === "PRODUCT_VARIANT"
                        ? "3px solid var(--loop-card-border-color)"
                        : "1px solid var(--loop-card-border-color)",
            }}
            className="me-2"
            body={true}
            variant={props.upsellCard ? "upsell" : null}
            id={`loop-${props.type}-product-${product?.product_shopify_id}`}
        >
            <div className="d-flex">
                <Image.ProductImage
                    size="sm"
                    style={{ width: "100px", height: "200px" }}
                    className="me-3 flex-shrink-0"
                    src={product.image}
                />
                <div className="d-flex flex-column justify-content-between flex-grow-1 py-1">
                    {props?.swapProfileData?.groupingType === "PRODUCT_VARIANT" ? (
                        <Text.P1 className="">
                            {props.type == "upsell-ribbon"
                                ? truncateText(`${product.product_title}-${product.variant_title}`, 36)
                                : `${product.product_title}-${product.variant_title}`}
                        </Text.P1>
                    ) : (
                        <Text.P1 className="">
                            {props.type == "upsell-ribbon"
                                ? truncateText(product.product_title, 36)
                                : product.product_title}
                        </Text.P1>
                    )}
                    <div className="d-flex justify-content-between">
                        {!product.isBYOB &&
                            (discountedPrice || discountedPrice == 0 ? (
                                <div className="d-flex align-items-baseline">
                                    <Text.P2 className="loop-text-muted my-1">
                                        {getCurrencyDisplayInternationalized(
                                            store.currency,
                                            locale,
                                            country,
                                            discountedPrice,
                                        )}
                                    </Text.P2>
                                    <span className="text-decoration-line-through ms-2 loop-text-superscript">
                                        {getCurrencyDisplayInternationalized(
                                            store.currency,
                                            locale,
                                            country,
                                            product.price,
                                        )}
                                    </span>
                                </div>
                            ) : (
                                <Text.P2 className="loop-text-muted my-1">
                                    {getCurrencyDisplayInternationalized(
                                        store.currency,
                                        locale,
                                        country,
                                        props.product.price,
                                    )}
                                </Text.P2>
                            ))}
                        {product.isBYOB && product.discountString && product.maxDiscount !== "0.00" ? (
                            <Text.P2 className="loop-text-muted my-1">
                                {" "}
                                {product.appliesOnEachItem
                                    ? translate("build_your_bundle_with_fixed_amount_per_item_discount", {
                                        discount_value: product.discountString,
                                    })
                                    : translate("build_your_bundle_with_percentage_fixed_discount", {
                                        discount_value: product.discountString,
                                    })}
                            </Text.P2>
                        ) : null}
                        {props.type == "upsell-ribbon" ? (
                            <div
                                className="d-flex justify-content-center align-items-center loop-add-product-btn-icon"
                                style={{ background: "#000", borderRadius: "50%", height: "25px", width: "25px" }}
                                id="loop-add-product-btn-icon"
                            >
                                <Icons.PlusSmall color="white" height="12" width="12" />
                            </div>
                        ) : (
                            <>
                                {props?.swapProfileData?.groupingType === "PRODUCT_VARIANT" ? null : (
                                    <Button
                                        className={props.upsellCard ? "loop-upsell-product-card-add-btn" : ""}
                                        size="sm"
                                        onClick={() => handleCardClick(product)}
                                    >
                                        {translate("select_product_select_button")}
                                    </Button>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Card>
    );
}

export default ProductCard;
